/**
 * @file routes/_app/settings/index.tsx
 * @description /settings 根路徑重定向。
 *
 * Header 用戶下拉的「個人設定」入口指向 /settings。為避免訪問 /settings 時
 * settings/route.tsx（純 layout outlet）下沒有 index 子頁而呈現空白頁，
 * 在此一律重定向到 /me/profile（真正的個人帳號設定頁）。
 *
 * 註：admin 角色側邊欄的「系統設定」是直接連 /settings/staff、/settings/clients
 * 等具體子頁，不受此重定向影響。
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/me/profile' });
  },
});
